import { render } from "./ArrowDown.vue?vue&type=template&id=31004754&scoped=true"
import script from "./ArrowDown.vue?vue&type=script&lang=js"
export * from "./ArrowDown.vue?vue&type=script&lang=js"

import "./ArrowDown.vue?vue&type=style&index=0&id=31004754&lang=scss&scoped=true"

import exportComponent from "/Users/amina/Desktop/streamup_amina/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31004754"]])

export default __exports__